<section>
  <div class="row middle-lg middle-xs center-lg center-xs">
    <div class="col-lg-12 col-xs-12">
      <div class="container">
        <app-title [titles]="[subTitle]" />
        <app-title [titles]="[title]" class="title" />
        <p class="paragraph">
          La page que vous recherchez n'existe pas, ou a été déplacée. Nous vous invitons néanmoins, à prolonger votre
          visite sur note site.
        </p>
        <div class="buttons">
          <app-button
            [icon]="{ name: 'CHEVRON_LEFT', position: 'LEFT' }"
            [url]="'/'"
            class="button"
            label="Retour à l'accueil"
            theme="TRANSPARENT_BLACK" />
          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
            [url]="'/realisations'"
            class="button"
            label="Nos réalisations"
            theme="BLUE" />
        </div>
      </div>
    </div>
  </div>
</section>
